// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import React, { Component } from 'react';
import debounce from 'debounce-promise';
import KitSelectAsync from '../KitFormComponents/KitSelectAsync';

interface OrgSelectionProps {
  url?: string;
  defaultOrgName?: string;
  isDisabled?: boolean;
  additionalColumns?: string;
  placeholder?: string;
  noRecordsMessage?: string;
  loadingMessage?: string;
  onChange?: (value?: unknown) => void;
  start?: number;
  count?: number;
}

interface OrgState {
  isDisabled: boolean;
  defaultOrgName: string;
  userOrgName: string;
}

class OrgSelection extends Component<OrgSelectionProps, OrgState> {
  searchUrl: string;

  constructor(props) {
    super(props);
    this.searchUrl = props.url ?? '/backend.php/globalfilter/searchOrg';
    this.state = {
      isDisabled: props.isDisabled ?? false,
      defaultOrgName: props.defaultOrgName ?? '',
      userOrgName: undefined,
    };
  }

  componentDidMount() {
    const formData = new FormData();
    formData.set('user_search', '');
    formData.set('only_name', '1');
    formData.set('count', '2');

    if (this.state.isDisabled === false || this.state.defaultOrgName === '') {
      fetch(this.searchUrl, {
        method: 'POST',
        body: formData,
      })
        .then((r) => r.json())
        .then((result) => {
          if (result.total_results === '1') {
            this.setState({
              userOrgName: result.content[0].name,
              isDisabled: true,
            });
            if (typeof this.props.onChange === 'function') {
              this.props.onChange(result.content[0]);
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }

  render() {
    const formData = new FormData();
    formData.set('additional_columns', this.props.additionalColumns ?? 'currency,currencySymbol');
    formData.set('start', String(this.props.start ?? 0));
    formData.set('count', String(this.props.count ?? 25));

    const debouncedLoadOptions = debounce((value) => {
      formData.set('user_search', value);

      return fetch(this.searchUrl, {
        method: 'POST',
        body: formData,
      })
        .then((r) => r.json())
        .then((result) => {
          if (result.content.length > 0) {
            return result.content;
          }

          return [];
        })
        .catch((error) => {
          console.error(error);
          return [];
        });
    }, 500);

    const getLabel = (data) => {
      return data.name;
    };

    const getID = (data) => {
      return data.id;
    };

    return (
      <KitSelectAsync
        isDisabled={this.state.isDisabled}
        defaultInputValue={this.state.defaultOrgName}
        inputValue={this.state.userOrgName}
        placeholder={this.props.placeholder ?? ''}
        noOptionsMessage={() => this.props.noRecordsMessage ?? 'No records'}
        loadingMessage={() => this.props.loadingMessage ?? 'Loading...'}
        onChange={this.props.onChange}
        getOptionLabel={(data) => getLabel(data)}
        getOptionValue={(data) => getID(data)}
        components={{
          IndicatorSeparator: null,
          DropdownIndicator: null,
        }}
        loadOptions={debouncedLoadOptions}
      />
    );
  }
}

export default OrgSelection;
